const initialState = {
  size: [100, 55],
  isRunning: false,
  speed: 500,
  message: null,
  color: null,
};

export default initialState;
